import React, { Fragment } from 'react';
import { Modal, Image, Button, Icon } from 'semantic-ui-react';
import { shape, func, arrayOf, string } from 'prop-types';

const ModalBody = ({ station, playStation, terms }) => (
  <Fragment>
    <Modal.Header>{station.name}</Modal.Header>
    <Modal.Content image>
      <Image
        wrapped
        size="medium"
        src={`https://www.twr360.org/images/sized/${
          station.logo
        }/c450x450/thumb.jpg?p=files/library`}
      />
      <Modal.Description>{station.description}</Modal.Description>
    </Modal.Content>
    <Modal.Actions>
      <Button primary onClick={() => playStation(station)}>
        <Icon name="play" />
        {terms[4]}
      </Button>

      <Button
        secondary
        as="a"
        href={station.website}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon name="external" />
        {terms[6]}
      </Button>
    </Modal.Actions>
  </Fragment>
);

ModalBody.propTypes = {
  station: shape().isRequired,
  playStation: func.isRequired,
  terms: arrayOf(string).isRequired
};

export default ModalBody;
